<!-- <p-chart type="bar" [data]="data"></p-chart> -->
<app-header></app-header>

<p-tabMenu
  #tab
  [model]="items"
  [activeItem]="activeItem"
  (click)="activateMenu(tab)"
></p-tabMenu>
<router-outlet></router-outlet>
